module.exports = __webpack_public_path__ + "static/media/md-browsers.5b3027fe.svg";